// BID_SU_TENDER_STATUS 轮次状态
const TENDER_STATUS = {
    NEW: '1', // 1: "新建"
    PUBILSH: '2', // 1: "已发布"
    OPEN: '3', // 1: "已开标"
    END: '4' // 1: "已结束"
};
const BID_STATUS = {
    NEW: '00', // 新建
    BIDPENDING: '10', // 标书待审
    BIDREJECT: '20', // 标书驳回
    BIDPASS: '30', // 标书通过
    INSORCE: '40', // 综合评分中
    SORCEDONE: '43', // 综合评分完成
    BIDPUBLISH: '50', // 标书发布
    STAMP: '53', // 推送价目表盖章 数字字典停用可以删除，涉及的逻辑也可以删除
    PENDINGTRIAL: '60', // 招标结果待审
    RESULTREJECT: '70', // 招标结果驳回
    AWARD: '80', // 完成决标
    ABANDONED: '90' // 废弃
};
// BID_SU_TENDER_TYPE 洽谈类型
const TENDER_TYPE = {
    ELECTRONIC: '1', // 电子报价
    OFFLINE: '2', // 线下议价
    BIDDING: '3' // 竞拍报价
};
const LOWER_LAST_ROUND = {
    NO: '0', // 否
    BYPACKAGE: '1', // 按包
    BYDETAILS: '2' // 按明细
};
const BUSINESS_TYPE = {
    DOCK: '2' // 装卸
};
export {
    TENDER_STATUS,
    BID_STATUS,
    TENDER_TYPE,
    LOWER_LAST_ROUND,
    BUSINESS_TYPE
};